import type { ClubContact } from "../lib/api";

/** "+15095551234" -> "(509) 555-1234"; anything that isn't a US/Canada
 *  number is shown as stored. */
export function formatPhone(e164: string): string {
  const m = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(e164);
  return m ? `(${m[1]}) ${m[2]}-${m[3]}` : e164;
}

/** A stored contact, ready to edit (phone shown the way people type it). */
export function contactDraft(contact: ClubContact | undefined): ClubContact {
  return { ...contact, phone: contact?.phone ? formatPhone(contact.phone) : "" };
}

/** The contact-detail inputs shared by Admin -> Clubs and Manage -> Advanced
 *  settings. The server (backend lib/clubContact.ts) validates on save. */
export default function ClubContactFields({
  idPrefix,
  value,
  onChange,
}: {
  idPrefix: string;
  value: ClubContact;
  onChange: (next: ClubContact) => void;
}) {
  const set = (key: keyof ClubContact) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
    onChange({ ...value, [key]: e.target.value });
  const gap = { marginBottom: "0.75rem" };
  return (
    <>
      <div style={gap}>
        <label htmlFor={`${idPrefix}-email`}>Contact email</label>
        <input
          id={`${idPrefix}-email`}
          type="email"
          maxLength={254}
          placeholder="board@yourclub.com"
          value={value.email ?? ""}
          onChange={set("email")}
        />
        <p className="muted" style={{ fontSize: 12, margin: "0.25rem 0 0" }}>
          Shown on the club's About page. Messages from its contact form go here.
        </p>
      </div>
      <div className="row" style={gap}>
        <div>
          <label htmlFor={`${idPrefix}-phone`}>Phone</label>
          <input
            id={`${idPrefix}-phone`}
            type="tel"
            maxLength={32}
            placeholder="(509) 555-1234"
            value={value.phone ?? ""}
            onChange={set("phone")}
          />
        </div>
        <div>
          <label htmlFor={`${idPrefix}-location`}>Location</label>
          <input
            id={`${idPrefix}-location`}
            maxLength={200}
            placeholder="Spokane, WA"
            value={value.location ?? ""}
            onChange={set("location")}
          />
        </div>
      </div>
      <div style={gap}>
        <label htmlFor={`${idPrefix}-about`}>About the club</label>
        <textarea
          id={`${idPrefix}-about`}
          rows={5}
          maxLength={4000}
          placeholder="Who you are, when and where you race, how to join."
          value={value.about ?? ""}
          onChange={set("about")}
        />
      </div>
    </>
  );
}
